import React from 'react';
import IntroSection from '../../component/introSection';
import ProgramStep from './component/programStep';
import { MainBgWrapper, ProgramBgWrapper } from '../../component/bgWrapper';
import ProgramService from './component/programService';

const IntroduceProgram : React.FC = () => (
  <ProgramBgWrapper
    id="program_introduce"
  >
    <MainBgWrapper>
      <IntroSection
        title="[프로그램 안내]"
        content={'늦은 시작은 없습니다.\n지금, 시럽 인연과 함께 하세요'}
      />
      <ProgramStep />
    </MainBgWrapper>
    {/* <PriceInfo /> */}
    <MainBgWrapper>
      <ProgramService />
    </MainBgWrapper>

  </ProgramBgWrapper>
);

export default IntroduceProgram;
